import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Trial started", { props: { triggerType: "Tag Added", tag: "trial-started", event: "trial-started" } }],
  ["f1s", "auto-field", "Add PQL points", { props: { field: "pql_score", op: "add" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["c1", "auto-condition", "Product-qualified?", { props: { condition: "pql_score is greater than 20 OR has tag 'invited-teammate'" } }],
  ["nt", "auto-notify", "Alert the AE", { props: { channel: "email", message: "PQL: {{contact.full_name}} scored {{contact.pql_score}}" } }],
  ["k1", "auto-task", "Personal outreach to the PQL", { props: { assignee: "Account exec", due: "+1 day" } }],
  ["e1", "auto-email", "Want a 15-minute walkthrough?", { props: { subject: "Saw you got the team in — want the shortcut?" } }],
  ["p1", "auto-pipeline", "Move to Demo Requested", { props: { pipeline: "Sales", stage: "Demo Requested" } }],
]);

const def: TemplateDef = {
  slug: "trial-to-demo-sales-assist",
  name: "Trial → Demo (Sales-Assist)",
  category: "SaaS",
  tagline:
    "Score trial behaviour, and only put a human in front of the accounts worth a human.",
  description:
    "A free product-led sales template: trial signups accumulate a PQL score from in-app events, a branch separates the product-qualified accounts, and only those get an AE alert, a call task and a demo invite. Clone it into FrazzleCRM to run product-led sales without a rep touching every trial.",
  whatsInside: [
    "A PQL score field your app increments over webhook or API",
    "Two-day scoring window before anyone is contacted",
    "Product-qualified branch that alerts an AE and creates a call task",
    "Demo booking page plus a pipeline stage move for forecast hygiene",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-seo", "SEO / Organic", 40, 60, { props: { keywords: "category + alternatives" } }),
      node("app", "prov-main-app", "Your app", 40, 220),
      node("su", "page-optin", "Trial signup", 360, 140, { props: { magnet: "14-day trial, no card" } }),
      flow("f1", "PQL Scoring & Handoff", 680, 40, 420, 856),
      ...seq.nodes,
      node("bk", "page-booking", "Demo calendar", 1200, 340, { props: { duration: "15 min" } }),
      node("out", "outcome-appointment", "Demo booked", 1520, 340),
      node("n1", "util-note", "What counts as a point", 360, 340, {
        notes:
          "Score the actions that predict paying, not the ones that predict browsing: invited a teammate, connected a data source, hit the second session. Fire them into Frazzle from your app and this branch does the qualifying.",
      }),
    ],
    [
      edge("src1", "su"),
      edge("app", "su"),
      edge("su", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
      edge("bk", "out"),
    ]
  ),
};

export default def;
